export const PartnerScoreDataAvailabilityTickIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Outlined/circle_checkmark">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1523 2C6.6295 2 2.15234 6.47715 2.15234 12C2.15234 17.5228 6.6295 22 12.1523 22C17.6752 22 22.1523 17.5228 22.1523 12C22.1523 6.47715 17.6752 2 12.1523 2ZM12.1523 4C16.5706 4 20.1523 7.58172 20.1523 12C20.1523 16.4183 16.5706 20 12.1523 20C7.73407 20 4.15234 16.4183 4.15234 12C4.1573 7.58378 7.73612 4.00496 12.1523 4ZM18.1523 9.42L16.7423 8L11.1523 13.59L8.56234 11.01L7.15234 12.42L11.1523 16.42L18.1523 9.42Z"
          fill="#0B41CD"
        />
      </g>
    </svg>
  );
};
